<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column is-5 has-text-white">
          <div>
            <img src="https://evgeshayoga.com/build/images/EvgeshaYogaWhite.svg"
                 alt="Evgesha Yoga - Йога с Женей, онлайн йога-программы">
          </div>
          <p>
            Поддержка: <a class="has-text-link-light" href="mailto:yoga@evgeshayoga.com">yoga@evgeshayoga.com</a>
          </p>
          <div>
            <ul class="social">
              <li class="mr-3">
                <p>Соц. сети</p>
              </li>
              <li class="social__link">
                <a class="has-text-link-light" href="//youtube.com/c/evgeshat" target="_blank" rel="noopener" title="Моя страница на YouTube">
                  <svg class="svg-inline--fa fa-youtube fa-w-18" aria-hidden="true" focusable="false" data-prefix="fab"
                       data-icon="youtube" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                       data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
                  </svg>
                </a>
              </li>
<!--              <li class="social__link">-->
<!--                <a class="has-text-link-light" href="//www.instagram.com/evgeshayoga" target="_blank" rel="noopener"-->
<!--                   title="Моя страница в Instagram">-->
<!--                  <svg class="svg-inline&#45;&#45;fa fa-instagram fa-w-14" aria-hidden="true" focusable="false"-->
<!--                       data-prefix="fab"-->
<!--                       data-icon="instagram" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"-->
<!--                       data-fa-i2svg="">-->
<!--                    <path fill="currentColor"-->
<!--                          d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>-->
<!--                  </svg>-->
<!--                </a>-->
<!--              </li>-->
              <li class="social__link">
                <a class="has-text-link-light" href="mailto:yoga@evgeshayoga.com">
                  <svg class="svg-inline--fa fa-envelope fa-w-16" aria-hidden="true" focusable="false" data-prefix="far"
                       data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                       data-fa-i2svg="">
                    <path fill="currentColor"
                          d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path>
                  </svg></a>
              </li>
            </ul>
          </div>
<!--          <div>-->
<!--            <a href="https://play.google.com/store/apps/details?id=com.evgeshayoga.evgeshayoga&amp;pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">-->
<!--              <img class="app-badge" alt="Доступно в Google Play"-->
<!--                   src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png">-->
<!--            </a>-->
<!--          </div>-->
        </div>
        <div class="column is-3 has-text-left">
          <p class="yoga-footer-link yoga-footer-link--title">
            <a class="has-text-link-light" href="https://evgeshayoga.com">На главную</a>
          </p>
          <p class="yoga-footer-link">
            <a class="has-text-link-light" href="https://evgeshayoga.com/videos">Йога Online</a>
          </p>
          <p class="yoga-footer-link">
            <a class="has-text-link-light" href="https://evgeshayoga.com/marathons">Курсы</a>
          </p>
          <p class="yoga-footer-link">
            <a class="has-text-link-light" href="https://evgeshayoga.com/workshops">События</a>
          </p>
        </div>
        <div class="column is-6 has-text-white">
          <p>© 2022 Evgesha Yoga. Все права защищены.</p>
          <p>
            <a class="has-text-grey-light" href="https://evgeshayoga.com/agreement">Лицензионное соглашение</a>
          </p>
          <p>
            <a class="has-text-grey-light" href="https://evgeshayoga.com/agreement-yoga-online">Пользовательское
              соглашение Йога Онлайн</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
<style>
.footer {
  background: #3B3E44;
}

.footer img {
  height: 2.5rem;
}

.app-badge {
  height: 3.5rem;
}

.social__link {
  width: 35px;
  text-align: center;
}

.svg-inline--fa {
  height: 1em;
  margin-top: -2px;
}

.social li {
  display: inline-block;
}
</style>